import React from 'react';
import { useNavigate } from 'react-router-dom';
import useFetchClientVehicles from '../../../hooks/clients/useFetchClientVehicles';
import CommonLoader from '../../shared/loaders/CommonLoader';
import Modal from '../../shared/modal/Modal';
import EmptyContent from '../../shared/table/EmptyContent';
import ClientVehiclesTable from '../ClientVehiclesTable';

const VehicleClientModal = ({ onModalClose }) => {
  const navigate = useNavigate();
  const { loading, vehicles } = useFetchClientVehicles();

  const onVehicleClick = async (vin) => {
    navigate(`/vehicles/${vin}`);
  };

  return (
    <Modal
      title={'Автомобілі клієнта'}
      loading={loading}
      onClose={onModalClose}
      body={
        loading ? (
          <CommonLoader />
        ) : (
          <>
            <ClientVehiclesTable vehicles={vehicles} onVehicleClick={onVehicleClick} />
            {vehicles.length === 0 && <EmptyContent title={'Список автомобілім порожній'} />}
          </>
        )
      }
    />
  );
};

export default VehicleClientModal;
